var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExplorer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.906.969h12.188s.937 0 .937.937v12.188s0 .937-.937.937H1.906s-.937 0-.937-.937V1.906s0-.937.937-.937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.899 10.288a.535.535 0 01-.774-.48V6.192a.535.535 0 01.774-.478l3.618 1.809a.534.534 0 010 .956z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGcgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTEuOTA2Ljk2OWgxMi4xODhzLjkzNyAwIC45MzcuOTM3djEyLjE4OHMwIC45MzctLjkzNy45MzdIMS45MDZzLS45MzcgMC0uOTM3LS45MzdWMS45MDZzMC0uOTM3LjkzNy0uOTM3Ii8+PHBhdGggZD0iTTYuODk5IDEwLjI4OGEuNTM1LjUzNSAwIDAgMS0uNzc0LS40OFY2LjE5MmEuNTM1LjUzNSAwIDAgMSAuNzc0LS40NzhsMy42MTggMS44MDlhLjUzNC41MzQgMCAwIDEgMCAuOTU2eiIvPjwvZz48L3N2Zz4=";
export { SvgIconExplorer as ReactComponent };